import {AbstractControl, ValidationErrors} from '@angular/forms';
import {TuiDay, TuiTime} from '@taiga-ui/cdk';

export const requiredDateWithHour = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value as [TuiDay | null, TuiTime | null] | undefined;

  if (!value || !value[0] || !value[1]) {
    return {requiredDateWithHour: 'Data publikacji musi zawierać godzinę.'};
  }

  return null;
};

/** Used for not required date inputs when value is supplied but the field itself is optional */
export const requiredDateWithHourWhenValue = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value as [TuiDay | null, TuiTime | null] | undefined;

  if (value && value?.[0] && !value?.[1]) {
    return {requiredFullDateWithHourValue: 'Data publikacji musi zawierać godzinę.'};
  }

  return null;
};
